import { render, staticRenderFns } from "./SuperIntendencia2025.vue?vue&type=template&id=0463177e&scoped=true"
import script from "./SuperIntendencia2025.vue?vue&type=script&lang=js"
export * from "./SuperIntendencia2025.vue?vue&type=script&lang=js"
import style0 from "./SuperIntendencia2025.vue?vue&type=style&index=0&id=0463177e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0463177e",
  null
  
)

export default component.exports